import { Component } from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";
import { DataService } from "../../../../services/data.service";

@Component({
  selector: "modal-wrapper",
  template: `
      <div [class]="'modal fade '+ key" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{ props['title'] }}</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi finestra modale"></button>
            </div>
            <div class="modal-body">
              <div [innerHTML]="props.description"></div>
              <ng-container #fieldComponent></ng-container>
            </div>
            <div class="modal-footer">
              <button (click)="onClose($event)" class="btn btn-primary btn-sm" type="button" data-bs-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>
  `,
  styles: [
    `
      .modal-backdrop.fade {
        opacity: 0.2;
        z-index: 1040;
      }
      .modal-dialog {
        z-index: 2000!important;
      }
    `
  ]
})
export class ModalWrapperComponent extends FieldWrapper {

  constructor( private ds: DataService ) {
    super();
  }
  onClose($event: any) {
    if( this.model ) {
      this.ds.setModelData( this.model );
    }
    // if(this.props['parent']) {
      // this.form.get(this.props['parent'])?.setValue(this.model.email)
    // }
    // this.props['onClose']($event);
  }

}
